import React, { Component, createRef } from 'react';
import { IInput } from '../../../models/components/input-text';
import Translator from '../../../core/i18n';
const T = Translator.create();
export class Input extends React.Component<IInput> {
    public input: HTMLInputElement | null = null;
    public validateDiv: HTMLDivElement | null = null;
    public noneAlphaNumbericCount: number = 0;
    public state = {
        value: this.props.value,
        onComplate: false
    };

    constructor(props: any) {
        super(props);
    }

    public onchange = (event: any) => {
        this.setState({ value: event.target.value });
        if (this.props.onChange) {
            this.props.onChange(event.target.value);
        }

        if (this.input) {
            const regex = /^[a-zA-Z0-9]+$/;
            this.noneAlphaNumbericCount = 0;
            for (let index = 0; index < this.input.value.length; index++) {
                if (!regex.test(this.input.value.charAt(index))) {
                    this.noneAlphaNumbericCount++;
                }
            }
        }
    }

    public onKeyPress = (event: any) => {
        if (this.props.onkeypress) {
            this.props.onkeypress(event);
        }
    }

    public onComplated = (status: any) => {
        if (this.props.onComplate) {
            this.props.onComplate(status);
        }
    }

    public onFocus = (event: any) => {
        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
    }

    public onKeyUp = (event: any) => {
        if (this.props.onkeyUp) {
            this.props.onkeyUp(event);
        }
        const keyCode = event.keyCode || event.which;
        this.onValid(keyCode);
    }

    public componentDidMount = () => {
        if (this.input && this.props.dataParameter && this.props.dataParameter.length > 0) {
            this.props.dataParameter.map(x => (
                (this.input) ?
                    (
                        this.input.setAttribute('data-' + x.name, x.value)
                    ) : ('')
            ));
        }
    }

    public onValid = (key?: any) => {
        if (this.input) {
            if (this.input.validity.valid) {
                if (this.props.noneAlphanumericCharacters && this.props.noneAlphanumericCharacters > 0 && this.props.noneAlphanumericCharacters > this.noneAlphaNumbericCount) {
                    if (this.validateDiv) {
                        this.validateDiv.classList.remove('success');
                        this.validateDiv.classList.add('error');
                        this.validateDiv.innerHTML = '(' + (this.props.noneAlphanumericCharacters - this.noneAlphaNumbericCount).toString() + ') ' + T.t('r_componenet_input_none_alpha_numeric');
                        this.onComplated(false);
                        return false;
                    }
                } else if (this.validateDiv) {
                    this.validateDiv.classList.remove('error');
                    this.validateDiv.classList.add('success');
                    this.validateDiv.innerHTML = T.t('r_componenet_input_valid_message');
                    this.onComplated(true);
                    return true;
                }
            } else if (this.input.value === '' && this.validateDiv) {
                this.validateDiv.classList.remove('success');
                this.validateDiv.classList.add('error');
                this.validateDiv.innerHTML = T.t('r_componenet_input_required_message');
                this.onComplated(false);
                return false;

            } else if (this.validateDiv) {
                this.validateDiv.classList.remove('success');
                this.validateDiv.classList.add('error');
                this.validateDiv.innerHTML = this.input.validationMessage;
                this.onComplated(false);
                return false;
            }
        }
    }

    public refInut = (e: any) => {
        this.input = e;
        if (this.props.refInput) {
            this.props.refInput(e);
        }
    }

    public render() {
        if (this.props.errorMessage && this.validateDiv) {
            this.validateDiv.innerText = this.props.errorMessage;
        }
        return (
            <div className="k365-input">

                <label className='input-label'>{(this.props.placeHolder) ? this.props.placeHolder : ''}</label>
                <input
                    onInvalid={this.onValid}
                    maxLength={(this.props.maxLenght) ? this.props.maxLenght : undefined}
                    minLength={(this.props.minLenght) ? this.props.minLenght : undefined}
                    placeholder={(this.props.placeHolder) ? this.props.placeHolder : ''}
                    ref={e => this.refInut(e)}
                    onKeyPress={(this.onKeyPress) ? this.onKeyPress : undefined}
                    onKeyUp={(this.onKeyUp) ? this.onKeyUp : undefined}
                    value={(this.state.value) ? this.state.value : ''}
                    type={(this.props.type) ? this.props.type : 'text'}
                    onFocus={(this.onFocus) ? this.onFocus : undefined}
                    onChange={(this.onchange) ? this.onchange : undefined}
                    required={(this.props.required) ? this.props.required : false}
                    pattern={(this.props.inputPattern) ? this.props.inputPattern : '[^]*'} />
                <div ref={e => this.validateDiv = e} className="" />
            </div>
        );
    }
}

export default Input;